import { render } from "./FeaturesList.vue?vue&type=template&id=30a224fc&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"

import "./FeaturesList.vue?vue&type=style&index=0&id=30a224fc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a224fc"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QImg});
